document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.responsive-hero[data-section-id]').forEach((heroElement) => {
    const hero = /** @type {HTMLElement} */ (heroElement);
    const slides = /** @type {NodeListOf<HTMLElement>} */ (hero.querySelectorAll('[data-slide]'));
    const dots = /** @type {NodeListOf<HTMLButtonElement>} */ (hero.querySelectorAll('[data-dot]'));
    const previousButton = /** @type {HTMLButtonElement | null} */ (hero.querySelector('[data-prev]'));
    const nextButton = /** @type {HTMLButtonElement | null} */ (hero.querySelector('[data-next]'));
    const totalSlides = slides.length;

    if (totalSlides <= 1) return;

    let currentIndex = 0;
    /** @type {ReturnType<typeof setInterval> | null} */
    let timer = null;
    const autoplay = hero.dataset.autoplay === 'true';
    const autoplaySpeed = parseInt(hero.dataset.autoplaySpeed || '5000', 10);

    /** @param {number} index */
    function showSlide(index) {
      const nextIndex = (index + totalSlides) % totalSlides;
      const currentSlide = slides[currentIndex];
      const nextSlide = slides[nextIndex];

      if (!currentSlide || !nextSlide) return;

      currentSlide.classList.remove('is-active');
      dots[currentIndex]?.classList.remove('is-active');
      dots[currentIndex]?.setAttribute('aria-selected', 'false');

      currentIndex = nextIndex;
      nextSlide.classList.add('is-active');
      dots[currentIndex]?.classList.add('is-active');
      dots[currentIndex]?.setAttribute('aria-selected', 'true');
    }

    function nextSlide() {
      showSlide(currentIndex + 1);
    }

    function previousSlide() {
      showSlide(currentIndex - 1);
    }

    function stopAutoplay() {
      if (timer) clearInterval(timer);
      timer = null;
    }

    function startAutoplay() {
      if (!autoplay) return;
      stopAutoplay();
      timer = setInterval(nextSlide, autoplaySpeed);
    }

    nextButton?.addEventListener('click', () => {
      nextSlide();
      startAutoplay();
    });

    previousButton?.addEventListener('click', () => {
      previousSlide();
      startAutoplay();
    });

    dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        showSlide(parseInt(dot.dataset.index || '0', 10));
        startAutoplay();
      });
    });

    hero.addEventListener('mouseenter', stopAutoplay);
    hero.addEventListener('mouseleave', startAutoplay);
    hero.addEventListener('focusin', stopAutoplay);
    hero.addEventListener('focusout', startAutoplay);

    startAutoplay();
  });
});
